export * from './utilities/color/index';
//# sourceMappingURL=Color.js.map